import { BindingEngine, autoinject, bindable, bindingMode, customElement, observable } from 'aurelia-framework';
import { ValidateResult } from 'aurelia-validation';
import { Router, activationStrategy } from 'aurelia-router';
import { Config } from 'Config';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { DataService } from 'DataAccessLayer/Services/DataService';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { Layout } from 'Common/Layout/Layout';
import { LayoutHelper } from 'Common/Layout/LayoutHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { SaveProgress } from 'Code/Extension/Progress';
import { Toastr } from 'Code/Extension/Toastr';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { FormLogicEngine } from 'Code/Helpers/FormLogicEngine';
import { ValidationHelper } from 'Code/Helpers/ValidationHelper';
import { EventAggregator } from 'aurelia-event-aggregator';

@autoinject
export class EntityPickerBaseCustomElement extends BaseCustomElement {

    @bindable({ defaultBindingMode: bindingMode.twoWay }) value: number = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) caption: string = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) imageId: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) creditCheckMainStatusId: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) imageHeight: number = 30;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) gpsCaption: string = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) gpsValue: string = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) mainProjection: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) editable: boolean = true;
    @bindable({ defaultBindingMode: bindingMode.toView }) deleted: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) description: string = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) referenceGpsColName: string = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) columnName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) modalOutput: Array<Object> = [];
    @bindable({ defaultBindingMode: bindingMode.toView }) canRenderSelectModalContent: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) canRenderCreateModalContent: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) enableCreate: boolean = true;
    @bindable({ defaultBindingMode: bindingMode.toView }) enablePickerCreate: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) modalCreateOutput: Object = {};
    @bindable({ defaultBindingMode: bindingMode.toView }) formLogic: Object = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) onChange: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) openModalCreate: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) openModalSelect: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) showPreviewModal: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) forceChange: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) reset: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) enableGetSimpleTooltip: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityData: Object = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) rowData: Object = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) tabIndexId: number = -1;
    @bindable({ defaultBindingMode: bindingMode.toView }) callDialNumbers: Array<string> = [];
    @bindable({ defaultBindingMode: bindingMode.toView }) configJson: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) placeholder: string = '';
    @bindable({ defaultBindingMode: bindingMode.toView }) fieldMode: string = 'EditForm';

    protected id: string = StringHelper.Empty();
    protected element: any = null;
    protected customElement: any = null;
    protected entityTypeName: string = StringHelper.Empty();
    protected schemaEntityTypeName: Object = null;
    protected schema: Object = null;
    protected foreignEntitySchema: any = null;
    protected dataService: DataService = null;
    protected authService: AuthService = null;
    protected formLogicEngine: FormLogicEngine = null;
    protected router: Router = null;
    protected openSelectModalDialog: boolean = false;
    protected autocompleteArray: Array<Object> = null;
    protected modalColumnDefinition: Array<string> = [];
    protected selectButton: boolean = false;
    protected redirectButton: boolean = false;
    protected removeButton: boolean = false;
    protected createButton: boolean = false;
    protected originCaption: string = StringHelper.Empty();
    protected changeEventLock: boolean = false;
    protected layout: Layout = null;
    //protected hasUlFocus: boolean = false;
    protected expanded: boolean = false;
    protected imageZoomEnabled: boolean = false;
    protected index: number = -1;
    protected suggestionsUL: any = null;
    protected userInput: String = '';
    protected updatingInput: boolean = false;
    protected isAddedEventListenerOnBodyClick: boolean = false;
    protected phoneLineNumbers: Array<string> = null;
    protected validationHelper: ValidationHelper = null;
    protected validationRulesCreateOutput: Array<any> = [];

    protected fieldConfig: any = {
        "ImageEnabled": true,
        "CallDialNumberEnabled": true,
        "PreviewButtonEnabled": true,
        "CreditCheckEnabled": true,
        "GpsDistanceEnabled": true,
        "SearchButtonEnabled": true,
        "EditButtonEnabled": true,
        "RemoveButtonEnabled": true
    }

    protected gpsDistanceValues: Array<any> = [
        { "Id": 5, "Caption": "5 km", "Description": "5 km" },
        { "Id": 10, "Caption": "10 km", "Description": "10 km" },
        { "Id": 20, "Caption": "20 km", "Description": "20 km" },
        { "Id": 50, "Caption": "50 km", "Description": "50 km" },
    ];

    protected modalFilter: Object = {};
    protected modalFilterByRecord: Object = {};

    protected myHideAutocompleteCallback: any = null;

    protected userToken: string = null;
    protected apiUrl: string = null;

    protected ea: EventAggregator = null;
    protected sub: any = null;

    collapse() {
        this.expanded = false;
        this.index = -1;
    }

    constructor(element: Element, dataService: DataService, router: Router, authService: AuthService, formLogicEngine: FormLogicEngine, validationHelper: ValidationHelper, eventAggregator: EventAggregator) {
        super();

        this.element = element;
        this.dataService = dataService;
        this.router = router;
        this.authService = authService;
        this.formLogicEngine = formLogicEngine;
        this.validationHelper = validationHelper;
        this.ea = eventAggregator;

        this.id = GuidHelper.NewGuid();

        this.myHideAutocompleteCallback = this.HideAutocomplete.bind(this);

        this.phoneLineNumbers = this.authService.GetUserPhoneLineNumbers();

        this.userToken = JSON.parse(localStorage[Config.TokenName()] || null).Token;
        this.apiUrl = Config.ApiUrl()

    }

    display(name) {
        this.updatingInput = true;
        this.caption = name;
        this.updatingInput = false;
    }

    keydown(key) {
        if (!this.expanded) {
            return true;
        }

        // down
        if (key === 40) {
            if (this.index < this.autocompleteArray.length - 1) {
                this.index++;
                this.display(this.getName(this.autocompleteArray[this.index]));
            } else {
                this.index = -1;
                this.display(this.originCaption);
            }
            this.scroll();
            return;
        }

        // up
        if (key === 38) {
            if (this.index === -1) {
                this.index = this.autocompleteArray.length - 1;
                this.display(this.getName(this.autocompleteArray[this.index]));
            } else if (this.index > 0) {
                this.index--;
                this.display(this.getName(this.autocompleteArray[this.index]));
            } else {
                this.index = -1;
                this.display(this.userInput);
            }
            this.scroll();
            return;
        }

        // escape
        if (key === 27) {
            if (ObjectHelper.IsNullOrUndefined(this.value)) {
                this.value = null;
                this.deleted = false;
                this.caption = null;
                this.imageId = null;
                this.originCaption = null;
                this.collapse();
            } else if (this.value > 0) {
                this.SelectAutocompleteValue(this.value, this.originCaption, this.mainProjection, this.imageId);
                this.display(this.originCaption);
                this.collapse();
            }
            return;
        }

        // enter
        if (key === 13) {
            if (this.index >= 0) {
                this.select(this.autocompleteArray[this.index]);
                this.collapse();
            }
            return;
        }

        return true;
    }

    scroll() {
        const ul = this.suggestionsUL;
        const li = ul.children.item(this.index === -1 ? 0 : this.index);
        if (li.offsetTop + li.offsetHeight > ul.offsetHeight) {
            ul.scrollTop += li.offsetHeight;
        } else if (li.offsetTop < ul.scrollTop) {
            ul.scrollTop = li.offsetTop;
        }
    }

    async select(selectedItem) {
        await this.SelectAutocompleteValue(selectedItem.Id, selectedItem.Caption, selectedItem.MainProjection, selectedItem.Image_FK);
    }

    getName(suggestion) {
        if (ObjectHelper.IsNotNullAndUndefined(suggestion) && ObjectHelper.IsNotNullAndUndefined(suggestion['Caption'])) {
            return suggestion.Caption;
        } else {
            suggestion;
        }
    }

    focus() {
        this.element.firstElementChild.focus();
    }

    compareSetValue(force: boolean) {
        if (!force && ObjectHelper.IsNotNullAndUndefined(this.autocompleteArray) && this.autocompleteArray.length > 0) {
            if (StringHelper.IsNullOrEmptyOrUndefined(this.caption)
                && !StringHelper.IsNullOrEmptyOrUndefined(this.originCaption)) {
                this.caption = this.originCaption;
            }
            return;
        } else if (!StringHelper.IsNullOrEmptyOrUndefined(this.originCaption)) {
            if (this.originCaption != this.caption && ObjectHelper.IsNotNullAndUndefined(this.value)) {
                this.value = null;
                this.deleted = false;
            }
        }
    }

    blur() {
        this.compareSetValue(false);
    }

    async bind() {
        this.imageZoomEnabled = await SystemService.Instance.GetSchemaProperty('ImageZoomEnabled')
        this.schema = await SystemService.Instance.GetSchemaByEntity(this.entityName);
        this.entityTypeName = await SystemService.Instance.GetEntityName(this.entityName, this.columnName);
        this.foreignEntitySchema = await SystemService.Instance.GetSchemaByEntity(this.entityTypeName);
        this.enableCreate = this.enableCreate && ObjectHelper.IsNotNullAndUndefined(this.foreignEntitySchema) && ObjectHelper.IsNotNullAndUndefined(this.foreignEntitySchema.AccessRight) && this.foreignEntitySchema.AccessRight.Create;
        if (ObjectHelper.ObjectIs(this.foreignEntitySchema)) {
            //
            this.modalColumnDefinition.push('Id');
            this.modalColumnDefinition.push('Caption');
            this.modalColumnDefinition.push('MainProjection');
        }

        if (ObjectHelper.ObjectIs(this.foreignEntitySchema) && Object.keys(this.foreignEntitySchema).length > 0) {
            if (this.enablePickerCreate) {
                this.selectButton = true;
                this.redirectButton = true;
                this.createButton = true;
                this.removeButton = true;
            }
            else {
                this.selectButton = true;
                this.redirectButton = true;
                this.createButton = false;
                this.removeButton = true;
            }
        }
        else {
            this.selectButton = false;
            this.redirectButton = false;
            this.createButton = false;
            this.removeButton = true;
        }

        //
        await this.UpdateEntityDescritption(this.value);

        if (this.fieldMode == 'FilterForm') {
            const FilterFieldConfig = await SystemService.Instance.GetSchemaProperty('FilterFieldConfig');
            if (ObjectHelper.ObjectIs(FilterFieldConfig) && ObjectHelper.ObjectIs(FilterFieldConfig.Entity)) {
                this.fieldConfig = FilterFieldConfig.Entity;
            }
        }
    }

    attached() {
        //
        if (StringHelper.IsNullOrEmpty(this.originCaption)) {
            this.originCaption = this.caption;
        }

        this.customElement = ($(this.element) as any);

        this.sub = this.ea.subscribe('optim-call-agent-line-number', async response => {
            this.phoneLineNumbers = this.authService.GetUserPhoneLineNumbers();
        });
    }

    detached() {
        // document.getElementById(`${this.id}-${this.entityName + '-' + this.columnName}-Caption`).removeEventListener("keydown");
        document.body.removeEventListener('click', this.myHideAutocompleteCallback);
        this.sub.dispose();
    }

    valueChanged(newValue, oldValue) {
        this.changeEventLock = true;
        if (ObjectHelper.IsNullOrUndefined(newValue) || StringHelper.IsNullOrEmpty(newValue)) {
            this.value = null;
            this.deleted = false;
        }

        if (ObjectHelper.IsNotNullAndUndefined(this.onChange) && !this.forceChange) {
            this.onChange();
        }
    }

    async resetChanged(newValue, oldValue) {
        if (ObjectHelper.IsNotNullAndUndefined(this.reset) && this.reset == true) {
            await this.RemoveSelectedData();
            this.originCaption = StringHelper.Empty();
            this.reset = false;
        }
    }

    protected getFilterByRecord(): any {
        let filterByRecord: any = {};
        if (this.ObjectIs(this.configJson) && this.ObjectIs(this.configJson.FilterByThisRecordEnabled)
            && this.configJson.FilterByThisRecordEnabled == true) {
            filterByRecord.RecordData = this.entityData;
            filterByRecord.RowData = this.rowData;
            filterByRecord.EntityName = this.entityName;
            filterByRecord.ColumnName = this.columnName;
        }
        return filterByRecord;
    }

    async captionChanged(newValue, oldValue) {
        if (this.index != -1) {
            return;
        } else if (this.index == -1 && newValue === oldValue) {
            return;
        }
        // check if new value isn't null or empty
        if (await ObjectHelper.IsNullOrUndefined(newValue) || await StringHelper.IsNullOrEmpty(newValue)) {
            this.caption = null;
            await this.UpdateEntityDescritption(null);
        }
        //
        if (!this.changeEventLock && ObjectHelper.IsNotNullAndUndefined(newValue) && !StringHelper.IsNullOrEmptyOrUndefined(newValue) && newValue.length > 1) {
            // load data from server

            if (ObjectHelper.ObjectIs(this.foreignEntitySchema) && ObjectHelper.ObjectIs(this.foreignEntitySchema.AccessRight) && this.foreignEntitySchema.AccessRight.Read) {
                let filter: Object = {}
                if (ObjectHelper.IsNotNullAndUndefined(this.formLogic) && ObjectHelper.IsNotNullAndUndefined(this.formLogic['FilterDependsOn'])) {
                    for (let i in this.formLogic['FilterDependsOn']) {
                        let map = this.formLogic['FilterDependsOn'][i];
                        if (ObjectHelper.IsNotNullAndUndefined(map.To)) {
                            if (ObjectHelper.IsNotNullAndUndefined(map.From) && this.entityData.hasOwnProperty(map.From)) {
                                filter[map.To] = this.entityData[map.From];
                            }
                            if (ObjectHelper.IsNotNullAndUndefined(map.Value)) {
                                filter[map.To] = map.Value;
                            }
                        }
                        if (ObjectHelper.IsNotNullAndUndefined(map.ToArray)) {
                            if (ObjectHelper.IsNotNullAndUndefined(map.From) && this.entityData.hasOwnProperty(map.From)) {
                                let arr1: Array<any> = [];
                                arr1.push(this.entityData[map.From]);
                                filter[map.ToArray] = arr1;
                            }
                        }
                    }
                }
                console.log(777, filter);
                let filterByRecord: any = this.getFilterByRecord();
                let response = await this.dataService.GetAutocomplete(this.entityTypeName, newValue, filter, filterByRecord);

                // check if response and data in the response aren't null
                if (ObjectHelper.IsNotNullAndUndefined(response) && ObjectHelper.IsNotNullAndUndefined(response['data'])) {
                    this.autocompleteArray = response['data'];

                    if (ObjectHelper.IsNotNullAndUndefined(this.autocompleteArray)
                        && this.autocompleteArray.length > 0) {
                        this.expanded = true;
                    }
                    //      
                    this.customElement.find('[role="autocomplete"]').show();

                    if (!this.isAddedEventListenerOnBodyClick) {
                        document.body.addEventListener('click', this.myHideAutocompleteCallback, false);
                        this.isAddedEventListenerOnBodyClick = true;
                    }
                } else {
                    this.autocompleteArray = null;
                }
            } else {
                this.autocompleteArray = null;
            }
        } else {
            this.autocompleteArray = null;
        }
        this.changeEventLock = false;
    }

    public async HideAutocomplete() {
        this.removeAutocompleteEventListener();
    }

    removeAutocompleteEventListener() {
        if (this.isAddedEventListenerOnBodyClick) {
            this.compareSetValue(true);
            document.body.removeEventListener('click', this.myHideAutocompleteCallback, false);
            this.customElement.find('[role="autocomplete"]').hide();
            this.isAddedEventListenerOnBodyClick = false;
        }
    }

    public async SelectAutocompleteValue(id: number, caption: string, mainProjection: string, imageId: number) {
        this.changeEventLock = true;

        // set value selected from autocomplete
        this.customElement.find('[role="value"]').val(id);
        this.customElement.find('[role="caption"]').val(caption);
        this.imageId = imageId;

        // set new selected ID
        this.value = id;
        this.deleted = false;
        this.caption = caption;
        this.mainProjection = mainProjection;
        this.originCaption = this.caption;
        // 
        await this.HideAutocomplete();
        await this.UpdateEntityDescritption(id);
    }

    public RedirectToSelectedData() {
        if (!StringHelper.IsNullOrEmptyOrUndefined(this.mainProjection)) {
            this.router.navigateToRoute('entityEdit', { entityName: this.mainProjection, entityId: this.value });
        }
        else {
            this.router.navigateToRoute('entityEdit', { entityName: this.entityTypeName, entityId: this.value });
        }
    }

    public async RemoveSelectedData() {
        // set value selected from modal picker
        this.customElement.find('[role="value"]').val('');
        this.customElement.find('[role="caption"]').val('');

        // set new selected ID
        this.value = null;
        this.deleted = false;
        this.caption = null;
        this.imageId = null;
        this.originCaption = null;
        this.changeEventLock = false;
        //
        await this.UpdateEntityDescritption(null);
    }

    public async OpenSelectModalDialog() {
        this.changeEventLock = true;
        if (this.fieldMode == 'ItemGrid') {
            if (ObjectHelper.IsNotNullAndUndefined(this.openModalSelect)) {
                this.openModalSelect();
            }
        }
        else {
            this.layout = await SystemService.Instance.GetListLayoutForEntity(this.entityTypeName);

            //
            if (ObjectHelper.IsNullOrUndefined(this.layout)) {
                //
                this.layout = await LayoutHelper.CreateDefaultListLayout(this.schema);
                //
                await SystemService.Instance.SaveLayoutForEntity(this.entityTypeName, 'list', this.layout, null);
            }

            // open
            this.canRenderSelectModalContent = true;

            this.modalFilter = {};
            if (ObjectHelper.IsNotNullAndUndefined(this.formLogic) && ObjectHelper.IsNotNullAndUndefined(this.formLogic['FilterDependsOn'])) {
                for (let i in this.formLogic['FilterDependsOn']) {
                    let map = this.formLogic['FilterDependsOn'][i];

                    if (ObjectHelper.IsNotNullAndUndefined(map.To)) {
                        if (ObjectHelper.IsNotNullAndUndefined(map.From) && this.entityData.hasOwnProperty(map.From)) {
                            this.modalFilter[map.To] = this.entityData[map.From];
                        }
                        if (ObjectHelper.IsNotNullAndUndefined(map.Value)) {
                            this.modalFilter[map.To] = map.Value;
                        }
                    }
                    if (ObjectHelper.IsNotNullAndUndefined(map.ToArray)) {
                        if (ObjectHelper.IsNotNullAndUndefined(map.From) && this.entityData.hasOwnProperty(map.From)) {
                            let arr1: Array<any> = [];
                            arr1.push(this.entityData[map.From]);
                            this.modalFilter[map.ToArray] = arr1;
                        }
                    }
                }
            }
            this.modalFilterByRecord = this.getFilterByRecord();

            // open modal dialog
            this.customElement.find('[role="dialog"][dialog-type="select"]').modal('show');
        }
    }

    public async onDoubleClick() {
        if (this.ArrayIs(this.modalOutput)) {
            await this.SelectModalValue();
        }
    }

    public async SelectModalValue() {
        this.changeEventLock = true;

        this.CloseSelectModal();

        // get values selected in modal picker
        let id = this.modalOutput[0]['Id'];
        let caption = this.modalOutput[0]['Caption'];
        let mainProjection = this.modalOutput[0]['MainProjection'];
        this.imageId = this.modalOutput[0]['Image_FK'];

        // set value selected from modal picker
        this.customElement.find('[role="value"]').val(id);
        this.customElement.find('[role="caption"]').val(caption);

        // set new selected ID
        this.value = id;
        this.deleted = false;
        this.caption = caption;
        this.mainProjection = mainProjection;
        this.originCaption = this.caption;
        //
        await this.UpdateEntityDescritption(id);
        //this.changeEventLock = false;
    }

    public CloseSelectModal() {
        this.canRenderSelectModalContent = false;
        this.customElement.find('[role="dialog"][dialog-type="select"]').modal('hide');
    }

    public async OpenCreateModalDialog() {
        //console.log(999, 'OpenCreateModalDialog', this.entityData, this.rowData, this.entityName, this.entityTypeName, this.configJson);
        if (this.fieldMode == 'ItemGrid') {
            if (ObjectHelper.IsNotNullAndUndefined(this.openModalCreate)) {
                this.openModalCreate();
            }
        }
        else {
            this.modalCreateOutput = {};
            let response = await this.dataService.GetById(this.entityTypeName, 0);
            if (ObjectHelper.IsNotNullAndUndefined(response) && response.hasOwnProperty('data') && response['data'] != null && response['data'] != ObjectHelper.Empty()) {
                this.modalCreateOutput = JSON.parse(JSON.stringify(response['data']));
            }

            if (this.ObjectIs(this.configJson) && this.ObjectIs(this.configJson.PickerCreate) && this.ArrayIs(this.configJson.PickerCreate.HeaderDataMap)) {
                for (let i1 = 0; i1 < this.configJson.PickerCreate.HeaderDataMap.length; i1++) {
                    let map: any = this.configJson.PickerCreate.HeaderDataMap[i1];
                    if (this.StringIs(map.From)) {
                        this.modalCreateOutput[map.To] = this.entityData[map.From];
                    }
                    else if (this.ObjectIs(map.Value)) {
                        this.modalCreateOutput[map.To] = map.Value;
                    }
                    else if (this.StringIs(map.EnumValue)) {
                        let enumType = await SystemService.Instance.GetEnumType(this.entityTypeName, map.To);
                        let enumItem: any = await SystemService.Instance.GetEnumerationItem(enumType, map.EnumValue, null);
                        if (ObjectHelper.IsNotNullAndUndefined(enumItem)) {
                            this.modalCreateOutput[map.To] = enumItem.Id;
                        }
                    }
                }
            }

            if (this.ObjectIs(this.configJson) && this.ObjectIs(this.configJson.PickerCreate) && this.ArrayIs(this.configJson.PickerCreate.RowDataMap)) {
                for (let i1 = 0; i1 < this.configJson.PickerCreate.RowDataMap.length; i1++) {
                    let map: any = this.configJson.PickerCreate.RowDataMap[i1];
                    if (this.StringIs(map.From)) {
                        this.modalCreateOutput[map.To] = this.rowData[map.From];
                    }
                    else if (this.StringIs(map.EnumValue)) {
                        let enumType = await SystemService.Instance.GetEnumType(this.entityTypeName, map.To);
                        let enumItem: any = await SystemService.Instance.GetEnumerationItem(enumType, map.EnumValue, null);
                        if (ObjectHelper.IsNotNullAndUndefined(enumItem)) {
                            this.modalCreateOutput[map.To] = enumItem.Id;
                        }
                    }
                }
            }

            if (this.ObjectIs(this.configJson) && this.ObjectIs(this.configJson.PickerCreate) && this.ArrayIs(this.configJson.PickerCreate.RowSetFromDetails)) {
                await this.formLogicEngine.FormLogic_SetColumnValuesFromDetails(this.modalCreateOutput, this.configJson.PickerCreate.RowSetFromDetails
                    , null, false, this.authService.GetUserInfo(), this.rowData, this.entityTypeName, this.schema);
            }

            if (this.ObjectIs(this.configJson) && this.ObjectIs(this.configJson.PickerCreate) && this.ArrayIs(this.configJson.PickerCreate.HeaderSetFromDetails)) {
                await this.formLogicEngine.FormLogic_SetColumnValuesFromDetails(this.modalCreateOutput, this.configJson.PickerCreate.HeaderSetFromDetails
                    , null, false, this.authService.GetUserInfo(), this.entityData, this.entityTypeName, this.schema);
            }

            if (this.ObjectIs(this.configJson) && this.ObjectIs(this.configJson.PickerCreate) && this.ObjectIs(this.configJson.PickerCreate.GetFromSp)) {
                let params = {
                    RecordData: JSON.parse(JSON.stringify(this.entityData)),
                    RecordEntityName: this.entityTypeName,
                    recordColumnName: this.columnName,

                    RowData: this.rowData,
                    RowEntityName: null,
                    RowColumnName: null,

                    RequestCounter: null
                };
                let apiResponse = await this.dataService.GetSpData(this.configJson.PickerCreate.GetFromSp.SpName, params);
                if (ObjectHelper.IsNotNullAndUndefined(apiResponse) && apiResponse.hasOwnProperty('data') && apiResponse['data'] != null && apiResponse['data'] != ObjectHelper.Empty()) {
                    let dataR = apiResponse['data'];
                    this.modalCreateOutput = JSON.parse(JSON.stringify(Object.assign(this.modalCreateOutput, dataR)));
                }
            }

            this.layout = await SystemService.Instance.GetEditLayoutForEntity(this.entityTypeName);
            if (ObjectHelper.IsNullOrUndefined(this.layout)) {
                this.layout = await LayoutHelper.CreateDefaultLayout(this.foreignEntitySchema);
                await SystemService.Instance.SaveLayoutForEntity(this.entityTypeName, 'edit', this.layout, null);
            }

            this.validationRulesCreateOutput = await this.validationHelper.createRules(this.entityTypeName, this.foreignEntitySchema, this.layout, false);
            console.log(999, 'OpenCreateModalDialog', this.entityTypeName, this.foreignEntitySchema, this.validationRulesCreateOutput);
            this.canRenderCreateModalContent = true;
            this.customElement.find('[role="dialog"][dialog-type="create"]').modal('show');
        }
    }

    public async onChangeEventCreateModal() {
        //console.log(777, 'onChangeEventCreateModal', this.entityTypeName, this.modalCreateOutput, this.validationRulesCreateOutput);
        await this.validationHelper.Validate(this.entityTypeName, this.modalCreateOutput, this.validationRulesCreateOutput);
    }

    public async SelectCreatedValue() {
        const validateResult: Array<ValidateResult> = await this.validationHelper.Validate(this.entityTypeName, this.modalCreateOutput, this.validationRulesCreateOutput);
        console.log(999, 'SelectCreatedValue', this.entityTypeName, this.modalCreateOutput, this.validationRulesCreateOutput, validateResult);
        if (ObjectHelper.ArrayIs(validateResult)) {
            Toastr.ValidateError(validateResult);
            return false;
        }
        SaveProgress.Show();
        let createResposne: any = await this.dataService.Create(this.entityTypeName, this.modalCreateOutput);

        switch (createResposne['status']) {
            case 'OK': {
                let getResponse = await this.dataService.GetByIdSimple(createResposne['data']['EntityName'], createResposne['data']['EntityID']);

                let id = getResponse['data']['Id']
                let caption = getResponse['data']['Caption'];

                this.customElement.find('[role="value"]').val(id);
                this.customElement.find('[role="caption"]').val(caption);

                this.value = id;
                this.deleted = false;
                this.mainProjection = getResponse['data']['MainProjectionName'];

                this.modalCreateOutput = {};
                await this.UpdateEntityDescritption(id);
                this.CloseCreateModal();
                SaveProgress.Hide();
                return;
            }
            case 'InvalidJson': {
                let mess = '';
                if (ObjectHelper.ArrayIs(createResposne.data)) {
                    for (let i1 = 0; i1 < createResposne.data.length; i1++) {
                        const item1: any = createResposne.data[i1];
                        mess = mess + await SystemService.Instance.GetPathLocalizationString(item1, this.schema) + " - " + item1.Message + '<br>';
                    }
                }
                Toastr.Error('Toastr.ThisFormIsNotValid', mess, false);
                SaveProgress.Hide();
                return;
            }
            default: {
                Toastr.Error('Toastr.Oooops', createResposne['message'], false);
                SaveProgress.Hide();
                return;
            }
        }
        SaveProgress.Hide();
        return;
    }

    public CloseCreateModal() {
        this.canRenderCreateModalContent = false;
        this.customElement.find('[role="dialog"][dialog-type="create"]').modal('hide');
        this.changeEventLock = false;
    }

    public async UpdateEntityDescritption(id: number) {
        if (ObjectHelper.IsNotNullAndUndefined(id) && ObjectHelper.IsNotNullAndUndefined(this.foreignEntitySchema) && this.enableGetSimpleTooltip
            && ObjectHelper.IsNotNullAndUndefined(this.foreignEntitySchema.AccessRight) && this.foreignEntitySchema.AccessRight.Read) {
            let resposne = await this.dataService.GetByIdSimple(this.entityTypeName, id);
            if (ObjectHelper.IsNotNullAndUndefined(resposne)) {
                let entityDataRef = resposne['data'];

                if (ObjectHelper.IsNotNullAndUndefined(entityDataRef)) {
                    this.description = entityDataRef['SimpleTooltip'];
                } else {
                    this.description = null;
                }
            }
        }
        else {
            this.description = null;
        }
    }

    public OpenPreviewModal() {
        this.showPreviewModal = true;
    }

    public async CallDialNumber(callFromLineNumber: string, number: string) {
        if (this.StringIs(number)) {
            SaveProgress.Show();
            let response = await this.dataService.OptimCallCallDial(callFromLineNumber.trim(), number.trim());
            if (this.ObjectIs(response) && response.hasOwnProperty('status')) {
                switch (response['status']) {
                    case 'OK': {
                        Toastr.Success('Toastr.Done', 'Toastr.Done');
                        SaveProgress.Hide();
                        return true;
                    }
                    default: {
                        Toastr.Error('Toastr.Oooops', '', false);
                        SaveProgress.Hide();
                        return false;
                    }
                }
            }
        }
    }
}